import React, { FC } from 'react';

import { HostProvider } from '../../../utils/HostProvider';
import tarjetaCaprabo from '../../../assets/images/tarjetas-caprabo.png';
import tarjetaEroski from '../../../assets/images/tarjetas.png';

interface Props {
  data: any;
  isPromocion: boolean;
}

const ImageProvaider: FC<Props> = ({ data, isPromocion }) => {
  const imageProvider = () => {
    return HostProvider.isEroski() ? (
      <img src={tarjetaEroski} alt="imagen de las tarjetas Eroski" />
    ) : (
      <img src={tarjetaCaprabo} alt="imagen de las tarjetas Caprabo" />
    );
  };

  return (
    <>
      <p className="u-font-normal">{`${data.textoTitulo}`}</p>
      <div className="bloque-vale__img">
        <div
          className={`img u-margin-right ${
            data.tipoVale !== 'ValeMonedero' && ' display-none'
          }`}
        >
          {!isPromocion && imageProvider()}
        </div>
      </div>
    </>
  );
};

export default ImageProvaider;
